import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
import { FormLabel, useId } from '../index.js';
export const FormInputChoice = ({ className, disabled, id, indeterminate, inputRef, label, labelProps, type = 'checkbox', ...rest }) => {
    const uId = useId();
    const htmlId = id || uId;
    // Autofocus input when outer div is clicked
    const fallbackRef = useRef(null);
    const ref = inputRef || fallbackRef;
    useEffect(() => {
        // Per the HTML Spec, `indeterminate` must be set via js directly instead of passed as an html attribute
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox#indeterminate
        if (ref.current)
            ref.current.indeterminate = !!indeterminate;
    }, [ref, indeterminate]);
    const input = (React.createElement("input", { className: cx('tds-form-input-choice', className), disabled: disabled, id: htmlId, ref: ref, type: type, ...rest }));
    return label ? (React.createElement("div", { className: cx('tds-form-input', { 'tds--disabled': disabled }) },
        input,
        React.createElement("div", { className: "tds-form-input-choice-label" },
            React.createElement(FormLabel, { ...labelProps, htmlFor: htmlId }, label)))) : (input);
};
